import declarationsReducre from "./declarationsSlice";

export default declarationsReducre;
